/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEgg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.914 7.348C6.718 9.4 6 11.905 6 13.708 6 17.223 8.724 20 12 20s6-2.778 6-6.291c0-1.804-.719-4.31-1.914-6.361-.594-1.018-1.277-1.876-1.997-2.469C13.37 4.287 12.667 4 12 4s-1.37.287-2.09.88c-.72.592-1.402 1.45-1.996 2.468zm.726-4.013C9.596 2.548 10.734 2 12 2s2.404.548 3.36 1.335c.955.786 1.78 1.85 2.454 3.006C19.152 8.637 20 11.486 20 13.709 20 18.249 16.456 22 12 22c-4.456 0-8-3.75-8-8.291 0-2.223.849-5.072 2.186-7.368.674-1.156 1.499-2.22 2.454-3.006z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEgg as Egg };
